import { render } from "./icons-share-alt.svg?vue&type=template&id=5cd228f8?inline"
const script = {}
script.render = render

export default script